import { render, staticRenderFns } from "./PreloaderPanel.vue?vue&type=template&id=ec2e8c4c&scoped=true&"
import script from "./PreloaderPanel.vue?vue&type=script&lang=js&"
export * from "./PreloaderPanel.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderPanel.vue?vue&type=style&index=0&id=ec2e8c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2e8c4c",
  null
  
)

export default component.exports